export default __webpack_public_path__ + "static/placeholder-img-cd8d9dd0d2ec3d6714a616a5c422c68f.jpg";